<template>
  <div>
    <recommended-video title="主播离线视频（匹配）" />
  </div>
</template>

<script>
import RecommendedVideo from '@/views/actor/RecommendedVideo'

export default {
  name: 'VideoOfflineMatch',
  components: {
    RecommendedVideo
  }
}
</script>
